require('./newsletter');
require('./cookies');
require('./dots');
require('./bookings');
require('./experts');
require('./circles');
require('./article-body');
require('./estimare');
require('./videos/index');
require('./fadeupText');
require('./swiper-cards');
require('./hovered-boxes');
require('./bubbles');
require('./pinned-slider');
require('./projects-horizontal');
require('./ported-general');
require('./customers-slide-v2');
require('./projects-home-swiper');
require('./tabs-circle-v2');
require('./videoSlidersInstaStory');
require('./knowledge-hub');
require('./market-insights-explorer');
require('./tabs-v2-slider');
require('./hero-portfolio');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js